import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  CHECK_DETAILS_BLOCK_DATA_SOURCE,
  CheckDetailsBlockDataSource,
} from './check-details-block-view-model';
import { CheckDetailsBlockPreviewDataSource } from './check-details-block-preview-data-source';
import { CheckDetailsBlockStoreDataSource } from './check-details-block-store-data-source';

export function provideCheckDetailsBlockDataSource(): Provider[] {
  return [
    CheckDetailsBlockStoreDataSource,
    CheckDetailsBlockPreviewDataSource,
    {
      provide: CHECK_DETAILS_BLOCK_DATA_SOURCE,
      useFactory: (): CheckDetailsBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(CheckDetailsBlockPreviewDataSource)
          : inject(CheckDetailsBlockStoreDataSource);
      },
    },
  ];
}
